import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#262626";
function CS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M12.886 7.219c1.84.135 2.732 1.234 2.732 1.432 0 .14-.033.447-.033.634q0 .188.135.6-.035.282-.372.282c-.338 0-.243-.379-.744-1.129-.54-.808-1.086-.977-1.72-1.012.012 1.722.06 6.462.063 8.092 1.691-.246 2.63-1.509 2.874-1.509.135 0 .304.105.304.353 0 .521-1.336 1.7-3.204 1.933-.14 1.522-.86 3.355-2.646 3.355-.845 0-1.555-.652-1.555-1.41 0-.494.372-.705.71-.705s.676.247.676.705q0 .459-.304.634.304.212.608.212c.677 0 1.185-1.224 1.272-2.797-1.97-.317-3.807-2.195-3.807-4.924 0-3.07 1.912-4.397 3.788-4.694.037-1.38.758-3.487 2.602-3.521 1.116 0 1.589.917 1.589 1.41 0 .494-.355.705-.71.705a.71.71 0 01-.71-.705q0-.423.338-.6a.88.88 0 00-.608-.21c-.938 0-1.233 1.978-1.279 2.869zm-1.19 8.84c-.003-1.825-.026-6.032-.032-7.964-1.731.425-2.3 2.484-2.3 3.87 0 2.196 1.037 3.704 2.332 4.095" clipRule="evenodd" /></Svg>;
}
CS.DefaultColor = DefaultColor;
export default CS;